module.exports = __webpack_public_path__ + "img/20.35501f65.jpg";